module.exports = __webpack_public_path__ + "img/0.252.17505bd7.png";